<template>
<div class="cm-actions-menu-container"> 
  <v-menu top>
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on">
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>

      <Box title="Actions" :show-close="true" :small="true" width="200px" headerColor="#0f74bb">
        <div>
          <ActionItem 
            v-for="option in extraOptionsFiltered"
            :key="option.text"
            :icon="option.icon"
            :label="option.text"
            @click.native="triggerExtra(option)"/>
          <ActionItem 
            v-if="options.includes('device')"
            label="Device Config"
            icon="mdi-settings"
            @click.native="toggleDeviceConfig()"/>
          <ActionItem 
            v-if="options.includes('logs')"
            label="Retrieve Logs"
            icon="mdi-file"
            @click.native="toggleLogComp()"/>
          <ActionItem
            v-if="options.includes('reboot')"
            label="Reboot Device"
            icon="mdi-power"
            @click.native="toggleReboot()" />
          <ShowOnMap v-if="options.includes('map')" :org="org" :device="device" />
          </div>
        </Box>
  </v-menu>

  <div v-show="showFSPanel" ref="actionsMenu" :style="boxPos" class="cm-actions-full-screen">
    <Loader :loading="loading" :spinner="true" />
    <!-- full screen popups go here! -->
    <DeviceConfig 
			v-if="displayDeviceConfig"
			:item="selectedDevice"
      :deviceId="device"
			:org="org ? org : null"
			@closeDeviceConfig="displayDeviceConfig = false" />

    <DownloadLog 
			:display="showLogs"
			:device="logItem" 
			:org="org"
			@closeLogComp="showLogs = false" />

    <DeviceReboot 
			v-if="displayReboot"
			:org="org"
			:device="rebootDevice"
			@close="displayReboot = false"
		/>
  </div>
</div>
</template>

<script>
import { mapState, mapGetters } from "vuex"
import { AmplifyEventBus } from "aws-amplify-vue"
import Box from "./Box.vue"
// import moment from "moment"
import ActionItem from '@/components/general/ActionItem.vue'
import ShowOnMap from '@/components/general/menu/ShowOnMap.vue'
import DeviceConfig from '@/components/deviceConfig/config.vue'
import DownloadLog from '@/views/OrgVehicles/components/DownloadLog.vue'
import DeviceReboot from '@/components/general/DeviceReboot.vue'
import { GetOrgVehicleByName } from "@/services/API"
import Loader from "@/components/general/Loader"
import { Logger } from "aws-amplify"
const logger = new Logger("ACTIONS MENU")

export default {
  components: {
    ActionItem,
    DeviceConfig,
    DownloadLog,
    DeviceReboot,
    Loader,
    ShowOnMap,
    Box
  },

  props: {
    device: {
      type: [String, null],
      default: () => false
    },
    // we do this to allow the older usage of show edit
    options: {
      type: Array,
      // full list of options available 
      default: () => ['device', 'logs', 'reboot', 'map']
    },
    extraOptions: {
      type: Array,
      default: () => []
    },
    org: {
      type: [String, Boolean],
      default: () => ''
    }
  },

  data () {
    return {
      // menu info
      showMenu: false,
      loading: false,

      // device config
      displayDeviceConfig: false, // show vehicle config menu
      selectedDevice: null,

      // logs info 
      showLogs: false,
      logItem: {},

      // reboot
      displayReboot: false,
      rebootDevice: null
    }
  },

  computed: {
    ...mapState (['goToken', 'driverHoursProviderName', 'telematicsProviderName', 'driverHoursProviderUrl', 'telematicsProviderUrl', 'DashBoardUserId']),
    ...mapGetters('presence', [
      'vehicleStatus', 'devicesMap'
    ]),
    ...mapState("app", ["drawer"]),
    // true if we should show the full screen panel for one of the config components
    showFSPanel () {
      return this.displayDeviceConfig || this.showLogs || this.displayReboot
    },
    // we show only extra options that have a text and an icon property
    extraOptionsFiltered () {
      return this.extraOptions.filter(i => typeof i == 'object' && i.text && i.icon)
    },
    boxPos() {
      const style = {
        'z-index': '2',
        position: 'fixed',
        top: '64px',
        left: this.drawer ? '259px' : '0px',
        margin: '0',
        padding: '0',
        width: '100%',
        height: '100%'
      }

      return style
    }
  },

  methods: {
    toggleMenu(e) {
      logger.debug("menu toggle", e)

      let allOptions = document.querySelectorAll(".cm-actions-menu");

      for (let option of allOptions) {
        option.classList.remove('active-options')

        if (e && option === e.target.nextSibling) {
          option.classList.toggle('active-options')
        } 
      }

      this.$nextTick(() => {
        let element = document.getElementById(this.device);
        let pageHeight = window.innerHeight;
        let elementHeight = element.clientHeight;
        let position = element.getBoundingClientRect().top;
 
        if(position + elementHeight > pageHeight) {
          e.target.nextSibling.classList.toggle('reposition');
        }
      })
    },

    // displays a toast error message
    toastError (msg) {
      AmplifyEventBus.$emit("snackEvent", {
          color: "error",
          text: msg
        })
    },

    toggleDeviceConfig() {
      logger.debug("get org vehicle info", this.devicesMap, this.devicesMap[this.device], this.device)
      this.loading = true

      if(!this.devicesMap || !this.device || !this.devicesMap[this.device]) {
        this.loading = false
        this.toastError("Could not retrieve Vehicle info")
      }

      GetOrgVehicleByName(this.org, this.devicesMap[this.device].vehicle_id, true).then(res => {
        this.selectedDevice = res
        this.displayDeviceConfig = true
        this.loading = false
      }).catch(err => {
        this.loading = false
        this.toastError("Could not retrieve Vehicle info")
        logger.debug(err)
      })

      setTimeout(() => {
        this.loading = false
      }, 2000)
    },

    toggleLogComp() {
      logger.debug("get org vehicle info", this.devicesMap, this.devicesMap[this.device], this.device)
      this.loading = true

      if(!this.devicesMap || !this.device || !this.devicesMap[this.device]) {
        this.loading = false
        this.toastError("Could not retrieve Vehicle info")
      }

      GetOrgVehicleByName(this.org, this.devicesMap[this.device].vehicle_id, true).then(res => {
        this.logItem = res
        this.showLogs = true
        this.loading = false
      }).catch(err => {
        this.loading = false
        this.toastError("Could not retrieve Vehicle info")
        logger.debug(err)
      })

      setTimeout(() => {
        this.loading = false
      }, 2000)
    },

    toggleReboot() {
      this.loading = true

      if(!this.devicesMap || !this.device || !this.devicesMap[this.device]) {
        this.loading = false
        this.toastError("Could not retrieve Vehicle info")
      }

      GetOrgVehicleByName(this.org, this.devicesMap[this.device].vehicle_id, true).then(res => {
        let devices = [{
          is_defaultdevice: true,
          device_id: this.device
        }]
        res.devices = devices
        this.rebootDevice = res
        this.displayReboot = true
        this.loading = false
      }).catch(err => {
        this.loading = false
        this.toastError("Could not retrieve Vehicle info")
        logger.debug(err)
      })

      setTimeout(() => {
        this.loading = false
      }, 2000)
      /*
      this.displayReboot = !this.displayReboot;

      if (item) {
        // We have to create these new properties on the object so that it remains compatible with the vehicles page
        let devices = [{
          is_defaultdevice: true,
          device_id: item.id
        }];

        item.devices = devices;
      }

      this.rebootDevice = item;
      */
    },

    // emits the event for an extra option passed in as a prop.
    triggerExtra (option) {
      this.$emit(`${option.text}`.replace(/\s/g, ''));
    },

    RefreshData () {
      logger.debug("refresh data")
    }
  }
}
</script>

<style lang="scss" scoped>
.cm-actions-menu-container {
  overflow: visible !important;
  position: relative;
  .cm-actions-menu {
    width: 250px;
    margin-left: -250px;
    position: absolute;
    z-index: 99;
    display: none;
  }
}
// style for the menu options
.action-launch {
  overflow: visible !important;
  position: relative;
  cursor: pointer;
}

.active-options {
  display: block !important;  
}
.cm-actions-full-screen {
  z-index: 999;
}

.reposition {
  bottom: 0;
}
</style>
